// extracted by mini-css-extract-plugin
module.exports = {"statusBlocked":"#ff6868","statusInProgress":"#ffc400","statusPending":"#0094ec","statusCompleted":"#00ca9a","statusApproval":"#bd02c6"};